"use client";

import { c as _c } from "react/compiler-runtime";
import { Col, Container, Row } from "react-bootstrap";
import { NextGenTokenImage } from "./nextgenToken/NextGenTokenImage";
import type { NextGenCollection, NextGenToken, TraitValuePair } from "@/entities/INextgen";
import { useEffect, useState } from "react";
import Pagination from "@/components/pagination/Pagination";
import { commonApiFetch } from "@/services/api/common-api";
import DotLoader from "@/components/dotLoader/DotLoader";
import { NextGenListFilters, NextGenTokenListedType, NextGenTokenRarityType } from "../nextgen_helpers";
import type { SortDirection } from "@/entities/ISort";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
interface Props {
  collection: NextGenCollection;
  limit?: number | undefined;
  sort?: NextGenListFilters | undefined;
  sort_direction?: SortDirection | undefined;
  selected_traits?: TraitValuePair[] | undefined;
  show_normalised?: boolean | undefined;
  show_trait_count?: boolean | undefined;
  listed_type?: NextGenTokenListedType | undefined;
  setTotalResults?: ((totalResults: number) => void) | undefined;
  show_pagination?: boolean | undefined;
}
export default function NextGenTokenList(props) {
  const $ = _c(48);
  const pageSize = props.limit ?? 48;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [tokens, setTokens] = useState(t0);
  const [tokensLoaded, setTokensLoaded] = useState(false);
  const [totalResults, setTotalResults] = useState(0);
  const [page, setPage] = useState(1);
  const [rarityType, setRarityType] = useState();
  let t1;
  if ($[1] !== pageSize || $[2] !== props) {
    t1 = function fetchResults(mypage) {
      setTokensLoaded(false);
      let endpoint = `nextgen/collections/${props.collection.id}/tokens?page_size=${pageSize}&page=${mypage}`;
      if (props.selected_traits) {
        const traitsQ = props.selected_traits.map(_temp).join(",");
        endpoint = endpoint + `&traits=${encodeURIComponent(traitsQ)}`;
      }
      if (props.show_normalised) {
        endpoint = endpoint + "&show_normalised=true";
      }
      if (props.show_trait_count) {
        endpoint = endpoint + "&show_trait_count=true";
      }
      if (props.listed_type === NextGenTokenListedType.LISTED) {
        endpoint = endpoint + "&listed=true";
      } else {
        if (props.listed_type === NextGenTokenListedType.NOT_LISTED) {
          endpoint = endpoint + "&listed=false";
        }
      }
      if (props.sort) {
        endpoint = endpoint + `&sort=${props.sort.replaceAll(" ", "_").toLowerCase()}`;
      } else {
        endpoint = endpoint + "&sort=random";
      }
      if (props.sort_direction) {
        endpoint = endpoint + `&sort_direction=${props.sort_direction.toLowerCase()}`;
      }
      commonApiFetch({
        endpoint
      }).then(response => {
        setTotalResults(response.count);
        if (props.setTotalResults) {
          props.setTotalResults(response.count);
        }
        setTokens(response.data);
        setTokensLoaded(true);
      });
    };
    $[1] = pageSize;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const fetchResults = t1;
  let t2;
  if ($[4] !== fetchResults || $[5] !== page) {
    t2 = () => {
      if (page === 1) {
        fetchResults(page);
      } else {
        setPage(1);
      }
    };
    $[4] = fetchResults;
    $[5] = page;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props.listed_type || $[8] !== props.selected_traits || $[9] !== props.show_normalised || $[10] !== props.show_trait_count || $[11] !== props.sort || $[12] !== props.sort_direction) {
    t3 = [props.selected_traits, props.sort, props.sort_direction, props.show_normalised, props.show_trait_count, props.listed_type];
    $[7] = props.listed_type;
    $[8] = props.selected_traits;
    $[9] = props.show_normalised;
    $[10] = props.show_trait_count;
    $[11] = props.sort;
    $[12] = props.sort_direction;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  useEffect(t2, t3);
  let t4;
  if ($[14] !== fetchResults || $[15] !== page) {
    t4 = () => {
      fetchResults(page);
    };
    $[14] = fetchResults;
    $[15] = page;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== page) {
    t5 = [page];
    $[17] = page;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  useEffect(t4, t5);
  let t6;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = function getRarityType(baseType, show_normalised, show_trait_count) {
      return NextGenTokenRarityType[`${baseType}${show_trait_count ? "_TRAIT_COUNT" : ""}${show_normalised ? "_NORMALISED" : ""}`] as NextGenTokenRarityType;
    };
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const getRarityType = t6;
  let t7;
  if ($[20] !== props) {
    t7 = () => {
      const {
        sort,
        show_normalised: show_normalised_0,
        show_trait_count: show_trait_count_0
      } = props;
      let newRarityType = undefined;
      bb43: switch (sort) {
        case NextGenListFilters.RARITY_SCORE:
          {
            newRarityType = getRarityType(NextGenTokenRarityType.RARITY_SCORE, show_normalised_0, show_trait_count_0);
            break bb43;
          }
        case NextGenListFilters.STATISTICAL_SCORE:
          {
            newRarityType = getRarityType(NextGenTokenRarityType.STATISTICAL_SCORE, show_normalised_0, show_trait_count_0);
            break bb43;
          }
        case NextGenListFilters.SINGLE_TRAIT_RARITY:
          {
            newRarityType = getRarityType(NextGenTokenRarityType.SINGLE_TRAIT_RARITY_SCORE, show_normalised_0, show_trait_count_0);
          }
      }
      setRarityType(newRarityType);
    };
    $[20] = props;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== props.show_normalised || $[23] !== props.show_trait_count || $[24] !== props.sort) {
    t8 = [props.sort, props.show_normalised, props.show_trait_count];
    $[22] = props.show_normalised;
    $[23] = props.show_trait_count;
    $[24] = props.sort;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  useEffect(t7, t8);
  let t9;
  if (tokensLoaded) {
    if (tokens.length > 0) {
      let t10;
      if ($[26] !== props.listed_type || $[27] !== props.sort || $[28] !== rarityType || $[29] !== tokens) {
        let t11;
        if ($[31] !== props.listed_type || $[32] !== props.sort || $[33] !== rarityType) {
          t11 = t_0 => <Col xs={6} sm={4} md={4} key={getRandomObjectId()} className="pt-3 pb-3"><NextGenTokenImage token={t_0} rarity_type={rarityType} show_listing={props.sort === NextGenListFilters.LISTED_PRICE || props.listed_type === NextGenTokenListedType.LISTED} show_max_sale={props.sort === NextGenListFilters.HIGHEST_SALE} show_last_sale={props.sort === NextGenListFilters.LAST_SALE} show_owner_info={true} /></Col>;
          $[31] = props.listed_type;
          $[32] = props.sort;
          $[33] = rarityType;
          $[34] = t11;
        } else {
          t11 = $[34];
        }
        t10 = tokens.map(t11);
        $[26] = props.listed_type;
        $[27] = props.sort;
        $[28] = rarityType;
        $[29] = tokens;
        $[30] = t10;
      } else {
        t10 = $[30];
      }
      t9 = t10;
    } else {
      let t10;
      if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = <Col className="pt-2 pb-2">No results found</Col>;
        $[35] = t10;
      } else {
        t10 = $[35];
      }
      t9 = t10;
    }
  } else {
    let t10;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <Col className="pt-2 pb-2"><DotLoader /></Col>;
      $[36] = t10;
    } else {
      t10 = $[36];
    }
    t9 = t10;
  }
  let t10;
  if ($[37] !== t9) {
    t10 = <Row>{t9}</Row>;
    $[37] = t9;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  let t11;
  if ($[39] !== page || $[40] !== pageSize || $[41] !== props.show_pagination || $[42] !== tokensLoaded || $[43] !== totalResults) {
    t11 = totalResults > pageSize && tokensLoaded && props.show_pagination && <Row className="text-center pt-4 pb-4"><Pagination page={page} pageSize={pageSize} totalResults={totalResults} setPage={function (newPage) {
        setPage(newPage);
        window.scrollTo(0, 0);
      }} /></Row>;
    $[39] = page;
    $[40] = pageSize;
    $[41] = props.show_pagination;
    $[42] = tokensLoaded;
    $[43] = totalResults;
    $[44] = t11;
  } else {
    t11 = $[44];
  }
  let t12;
  if ($[45] !== t10 || $[46] !== t11) {
    t12 = <Container className="no-padding">{t10}{t11}</Container>;
    $[45] = t10;
    $[46] = t11;
    $[47] = t12;
  } else {
    t12 = $[47];
  }
  return t12;
}
function _temp(t) {
  return `${t.trait}:${t.value}`;
}